import { render, staticRenderFns } from "./MemberScoreComponent.vue?vue&type=template&id=21fb5c8b&"
import script from "./MemberScoreComponent.vue?vue&type=script&lang=js&"
export * from "./MemberScoreComponent.vue?vue&type=script&lang=js&"
import style0 from "./MemberScoreComponent.vue?vue&type=style&index=0&id=21fb5c8b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports